export default __webpack_public_path__ + "static/media/girl_2.5c560b63.jpg";